import React, { memo } from 'react';
import { getPhoneHref } from 'src/utils';

const linkStyle = {
  color: '#0066cc',
  textDecoration: 'underline',
  cursor: 'pointer',
  fontWeight: '500',
};

const PhoneLink = ({ phone }) => {
  const href = getPhoneHref(phone);
  if (!href) return <>{phone ?? ''}</>;

  return (
    <a href={href} style={linkStyle}>
      {phone}
    </a>
  );
};

export default memo(PhoneLink);
